export default "__VITE_ASSET__WoRtGmWK__"